// Manual dark/light override, only rendered when @custom.color_scheme is "Auto".
// Two states: no override (follow system) <-> fixed opposite of system at time of toggling.
(function () {
    var STORAGE_KEY = 'northline-color-scheme';
    var LEGACY_STORAGE_KEY = 'meridian-color-scheme';
    var toggle = document.querySelector('[data-color-scheme-toggle]');
    var media = window.matchMedia('(prefers-color-scheme: dark)');

    if (!toggle) {
        return;
    }

    function systemPrefersDark() {
        return media.matches;
    }

    function readStoredOverride() {
        try {
            var stored = localStorage.getItem(STORAGE_KEY);

            if (stored !== 'light' && stored !== 'dark') {
                stored = localStorage.getItem(LEGACY_STORAGE_KEY);

                if (stored === 'light' || stored === 'dark') {
                    localStorage.setItem(STORAGE_KEY, stored);
                    localStorage.removeItem(LEGACY_STORAGE_KEY);
                }
            }

            return stored === 'light' || stored === 'dark' ? stored : null;
        } catch (error) {
            return null;
        }
    }

    var override = readStoredOverride();

    function persist(value) {
        try {
            if (value) {
                localStorage.setItem(STORAGE_KEY, value);
            } else {
                localStorage.removeItem(STORAGE_KEY);
            }
        } catch (error) {
            // The in-memory preference still works for this page view.
        }
    }

    function apply(value) {
        if (value) {
            document.documentElement.dataset.colorScheme = value;
            document.documentElement.style.colorScheme = value;
        } else {
            delete document.documentElement.dataset.colorScheme;
            document.documentElement.style.colorScheme = '';
        }
    }

    function reflect() {
        var active = override || (systemPrefersDark() ? 'dark' : 'light');

        toggle.classList.toggle('is-dark-active', active === 'dark');
        toggle.setAttribute('aria-pressed', String(Boolean(override)));
    }

    toggle.addEventListener('click', function () {
        if (override) {
            override = null;
        } else {
            override = systemPrefersDark() ? 'light' : 'dark';
        }

        persist(override);
        apply(override);
        reflect();
    });

    if (media.addEventListener) {
        media.addEventListener('change', reflect);
    }

    apply(override);
    reflect();
})();
